export default "__VITE_ASSET__f45bcee3__"